export const theMirror = {
  it: {
    title: "Il Costo del Silenzio Digitale",
    subtitle: "La differenza tra \"essere online\" e \"dominare il mercato\" non è il budget. È l'infrastruttura.",
    switch: {
      old: "La tua realtà oggi",
      new: "Il Potenziale Victor"
    },
    old: {
      loading: "Caricamento in corso...",
      contact: "Contattaci",
      error: "Connessione instabile"
    },
    new: {
      brand: "Brand",
      brandSuffix: "Future",
      menu: "Menu",
      performance: "PERFORMANCE: 100/100",
      headline: "Velocità è",
      headlineHighlight: "Fatturato.",
      cta: "Prenota Ora",
      conversion: "Conversione"
    }
  },
  en: {
    title: "The Cost of Digital Silence",
    subtitle: "The difference between \"being online\" and \"dominating the market\" is not budget. It's infrastructure.",
    switch: {
      old: "Your reality today",
      new: "The Victor Potential"
    },
    old: {
      loading: "Loading...",
      contact: "Contact Us",
      error: "Connection unstable"
    },
    new: {
      brand: "Brand",
      brandSuffix: "Future",
      menu: "Menu",
      performance: "PERFORMANCE: 100/100",
      headline: "Speed is",
      headlineHighlight: "Revenue.",
      cta: "Book Now",
      conversion: "Conversion"
    }
  }
};





